<template>
  <div>
    <el-row>
      <el-table
        :data="mertCaseList"
        class="collection-logs"
        border
        style="width: 100%"
      >
        <el-table-column prop="creeUser" label="报案人" />
        <el-table-column prop="creeTime" label="报案时间" min-width="150" />
        <el-table-column prop="caseRean" label="报案原因" min-width="150" />
        <el-table-column prop="caseStas" label="状态">
          <template slot-scope="scope">
            {{
              scope.row.caseStas == 0
                ? "待调查"
                : scope.row.caseStas == 1
                ? "调查中"
                : scope.row.caseStas == 2
                ? "已结案"
                : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="caseNote" label="描述" min-width="150" />
        <el-table-column prop="caseNate" label="案件定性" />
        <el-table-column prop="caseConn" label="最新调查结论" min-width="150" />
        <el-table-column prop="invePros" label="调查过程" min-width="150" />
        <el-table-column prop="modyUser" label="当前调查员" min-width="100" />
        <el-table-column prop="modyTime" label="最新调查时间" min-width="150" />
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="checkRecord(scope.row)"
              >查看调查记录</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-section">
        <el-pagination
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          :total="mertCaseListTotal"
          layout="total, sizes, prev, pager, next"
          @size-change="sizeChange"
          @current-change="changePage"
        />
      </div>
    </el-row>
    <el-dialog
      :visible.sync="showCaseSion"
      title="查看调查记录"
      @close="showCaseSion = false"
      width="800px"
    >
      <el-table
        :data="caseSionList"
        class="collection-logs"
        border
        style="width: 100%"
      >
        <el-table-column prop="creeTime" label="调查日期" min-width="150" />
        <el-table-column prop="creeUser" label="调查员" />
        <el-table-column prop="invePros" label="调查过程" min-width="150" />
        <el-table-column prop="caseSion" label="调查结论" min-width="150" />
        <el-table-column prop="caseNate" label="案件定性" />
      </el-table>
      <div class="pagination-section">
        <el-pagination
          :page-sizes="[5, 10, 15, 20]"
          :page-size="caseSionPageSize"
          :total="caseSionListTotal"
          layout="total, sizes, prev, pager, next"
          @size-change="caseSionSizeChange"
          @current-change="caseSionChangePage"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showCaseSion = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "item-collection-log",
  props: {
    taskId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      pageSize: 5,
      page: 0,
      casePkid: null,
      caseSionPageSize: 5,
      caseSionPage: 0,
      showCaseSion: false,
    };
  },
  computed: {
    ...mapGetters([
      "mertCaseList",
      "mertCaseListTotal",
      "caseSionList",
      "caseSionListTotal",
      "borrowerInfo",
    ]),
  },
  async created() {
    await this.fetchBorrowerInfo({ taskId: this.taskId });
    setTimeout(() => {
      this.queryMertCaseList({
        contractNumber: this.borrowerInfo.contractNumber,
        page: this.page,
        size: this.pageSize,
      });
    }, 800);
  },
  methods: {
    async checkRecord(row) {
      this.casePkid = row.pkid;
      this.caseSionPageSize = 5;
      this.caseSionPage = 0;
      await this.queryCaseSionList({
        casePkid: this.casePkid,
        contractNumber: this.borrowerInfo.contractNumber,
        page: this.caseSionPage,
        size: this.caseSionPageSize,
      });
      this.showCaseSion = true;
    },
    caseSionChangePage(currentPage) {
      this.caseSionPage = currentPage;
      this.queryCaseSionList({
        casePkid: this.casePkid,
        contractNumber: this.borrowerInfo.contractNumber,
        page: this.caseSionPage,
        size: this.caseSionPageSize,
      });
    },
    caseSionSizeChange(size) {
      this.caseSionPageSize = size;
      this.caseSionPage = 0;
      this.queryCaseSionList({
        casePkid: this.casePkid,
        contractNumber: this.borrowerInfo.contractNumber,
        page: this.caseSionPage,
        size: this.caseSionPageSize,
      });
    },
    ...mapActions([
      "fetchBorrowerInfo",
      "queryMertCaseList",
      "queryCaseSionList",
    ]),
    changePage(currentPage) {
      this.page = currentPage;
      this.queryMertCaseList({
        contractNumber: this.borrowerInfo.contractNumber,
        page: this.page,
        size: this.pageSize,
      });
    },
    sizeChange(size) {
      this.pageSize = size;
      this.page = 0;
      this.queryMertCaseList({
        contractNumber: this.borrowerInfo.contractNumber,
        page: this.page,
        size: this.pageSize,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.collection-logs {
  margin-top: 15px;
}
</style>
